import { Injectable, Input } from '@angular/core';
import { LocationRestService } from '../api/exa';
import { EmployerService } from './employer.service';
import { GeolocationService } from './geolocation.service';

@Injectable({
  providedIn: 'root',
})
export class WeighingFuelService {
  options = {
    enableHighAccuracy: true,
  };

  employerUsername = null;

  fuelLocations = [];
  scaleLocations = [];
  allLocations = null;

  constructor(
    private geolocation: GeolocationService,
    private locations: LocationRestService,
    private employer: EmployerService
  ) {
    this.geolocation.onPositionChange().subscribe((data) => console.log(data));

    this.employer.onSelectEmployer().subscribe((data) => {
      this.employerUsername = data.username;
    });
    this.locations.getLocationsUsingPOST(this.employerUsername).subscribe((loc) => {
      this.allLocations = loc.content;

      loc.content.forEach((location) => {
        if (location.type === 'FUEL') {
          this.fuelLocations.push(location);
        }
        if (location.type === 'WEIGHING') {
          this.scaleLocations.push(location);
        }
      });
    });
  }

  getLocs() {
    console.log(this.allLocations);
    console.log(this.fuelLocations);
    console.log(this.scaleLocations);
  }
}
